import * as React from 'react'
import { useSnapshot } from 'valtio'
import { dayHistoryState } from '../../../../store/dayHistoryState.ts'
import { DayHistoryPolyline } from './DayHistoryPolyline.tsx'
import { DayHistoryMarker } from './DayHistoryMarker.tsx'
import { DayHistoryPlayback } from './DayHistoryPlayback.tsx'

/**
 * Container for all Day History map elements.
 * Only renders when day history mode is active and data is loaded.
 * This component is rendered inside the history map view.
 */
export const DayHistoryMap: React.FC = () => {
    const active = (useSnapshot(dayHistoryState) as typeof dayHistoryState).active
    const pathData = (useSnapshot(dayHistoryState) as typeof dayHistoryState).pathData
    const loading = (useSnapshot(dayHistoryState) as typeof dayHistoryState).loading

    if (!active || !pathData || loading) return null

    // Empty path — the controls overlay handles the "no activity" message
    if (pathData.path.length === 0) return null

    return (
        <>
            <DayHistoryPlayback />
            <DayHistoryPolyline />
            <DayHistoryMarker />
        </>
    )
}
